
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.263 13.531c.287 0 .52-.225.52-.52V9.219c.17-.075.813-.322 1.818-.322 2.529 0 4.115 1.238 6.521 1.238 1.066 0 1.463-.116 1.982-.349.472-.212.78-.567.78-1.196V1.644c0-.363-.315-.581-.711-.581-.335 0-.964.293-2.14.293-2.406 0-3.985-1.244-6.521-1.244-1.067 0-1.47.117-1.99.349-.471.212-.779.574-.779 1.196v11.355c0 .28.24.52.52.52zm8.86-4.436c-2.277 0-3.89-1.23-6.522-1.23-.752 0-1.43.088-1.819.245V1.685c.096-.22.663-.534 1.73-.534 2.406 0 4.012 1.238 6.521 1.238.745 0 1.36-.09 1.819-.226v6.399c-.096.218-.664.533-1.73.533z","fill":"#AAB4C0"}})])
          )
        }
      }
    